import script from "./Site.vue?vue&type=script&setup=true&lang=ts"
export * from "./Site.vue?vue&type=script&setup=true&lang=ts"

import "./Site.vue?vue&type=style&index=0&id=68e0202a&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68e0202a"]])

export default __exports__